import React, { useState } from "react";
import { SummaryDetails } from "./SummaryDetails";
import { Permission } from "./Permission";
import { Modal } from "components/Modal";
import { ChangeRole } from "./ChangeRole";
import { useGetRoles } from "api/roles";

const MODAL_CONTENT = {
  PERMISSION: "PERMISSION",
  SUMMARY_DETAILS: "SUMMARY_DETAILS",
  CHANGE_ROLE: "CHANGE_ROLE",
};

export const TeamMateDetails = ({ data, open, onClose, onRoleUpdate }) => {
  const [content, setContent] = useState(MODAL_CONTENT.SUMMARY_DETAILS);

  const { data: roles } = useGetRoles();

  const team = roles?.filter((item) => item?.name === data?.roles);

  const PermissionModal = () => {
    setContent(MODAL_CONTENT.PERMISSION);
  };

  const ChangeRoleModal = () => {
    setContent(MODAL_CONTENT.CHANGE_ROLE);
  };

  const handleClose = () => {
    onClose();
    setContent(MODAL_CONTENT.SUMMARY_DETAILS);
  };
  return (
    <>
      {open && data ? (
        <Modal open={open} handleClose={handleClose}>
          {content === MODAL_CONTENT.SUMMARY_DETAILS && (
            <SummaryDetails
              handlePermission={PermissionModal}
              handleChangeRole={ChangeRoleModal}
              data={data}
            />
          )}

          {content === MODAL_CONTENT.PERMISSION && (
            <Permission rowData={data} roleId={team[0]?.roleId} />
          )}
          {content === MODAL_CONTENT.CHANGE_ROLE && (
            <ChangeRole
              data={data}
              roleId={team[0]?.roleId}
              onRoleUpdate={(id, newRole) => {
                onRoleUpdate(id, newRole);
                handleClose();
              }}
              onClose={handleClose}
            />
          )}
        </Modal>
      ) : null}
    </>
  );
};
